<template>
	<div class="both-wizard">
		<!-- Intro text  -->
		<div class="text">

		<!-- Guide Title area -->
			<div class="title-messages">
				<!-- <h3 >Select the correct estimator</h3> -->
		<!--	<h4>contextual reference<img class="icon" src="~Img/baseline-info-24px.svg"></h4> -->
			</div>
		</div>

	<!-- Here start accordeons component  -->
	<div class="accordeon-wizards">
		<b-modal id="modal1" ref="myModalRef" hide-footer size="lg" title="Important Term">
			<!-- Component PopUp -->

			<div style="width: 100%; display: flex; justify-content:center;">
				<b-button class="mt-3" variant="outline-success" style="width: 20%;" block @click="hideModal">Close</b-button>
			</div>
		</b-modal>

	<!-- Residential btn -->
		<b-btn id="btn1" block @click="changeTitleAndOpenAccordeon(1) "
			:class="showCollapseA ? 'collapsed' : null"
			aria-controls="collapse1"
			:aria-expanded="showCollapseA ? 'true' && changeTitleAndOpenAccordeon[1] : 'false' && changeTitleAndOpenAccordeon[0]" variant="info">

			<img v-if="!showCollapseA" src="~Img/baseline-expand_more-24px.svg"><img v-if="showCollapseA" src="~Img/baseline-expand_less-24px.svg"><span>Residential Cost Estimator</span>

		</b-btn>

		<b-collapse class="callapse" v-model="showCollapseA" id="collapse1">
			<b-card class="accor-body">

				<b-form-radio-group id="radios2" v-model="selectedFirstRadiosGroup" name="radioSubComponent">
					<div class="compliance-wizard">
							<div class="accor-body">
								<residentialWizards estimator='true' />
							<!-- <transition name="fade" mode="out-in">
								<div class="cost-estimator-inside" v-if="showCollapseA">
								</div>
							</transition> -->

							</div>

						</div>

						</b-form-radio-group>
					</b-card>
				</b-collapse>

				<b-btn id="btn2" class="bar" block @click="changeTitleAndOpenAccordeon(2) "
					:class="showCollapseB ? 'collapsed' : null"
					aria-controls="collapse2"
					:aria-expanded="showCollapseB ? 'true' && changeTitleAndOpenAccordeon[1] : 'false' && changeTitleAndOpenAccordeon[0]" variant="info">
					<img v-if="!showCollapseB" src="~Img/baseline-expand_more-24px.svg"><img v-if="showCollapseB" src="~Img/baseline-expand_less-24px.svg"><span>Commercial Cost Estimator</span>
				</b-btn>

				<b-collapse class="mt-2" v-model="showCollapseB" id="collapse2">
					<b-card class="accor-body">
						<b-form-radio-group id="radios2" v-model="selectedSecondRadiosGroup" name="radioSubComponent">
							<div class="a-2">
								<commercialWizards estimator='true' />
								<!-- <transition name="fade" mode="out-in">
									<div class="cost-estimator-inside" v-if="showCollapseB">
									</div>
								</transition> -->
						</div>
				</b-form-radio-group>
			</b-card>
		</b-collapse>

		</div>
	</div>
</template>

<script>
import eventBus from '@/commonSite/eventBus.js'
import residentialWizards from '@/components/complianceWizard/residentialWizards/menuResidential.vue'
import commercialWizards from '@/components/complianceWizard/commercialWizards/MenuComercial.vue'
export default {
	name: 'cost-estimator',
	components: {
		residentialWizards,
		commercialWizards
	},
	data: function () {
		return {
			guideMessages: ['Step 1: Specify the Occupancy Classification / Building Type', 'Step 2: What does your project consist of?',
				'Step 3: Now select the type of work to be performed to know the cost'],
			titlemessages: 'Step 1: Specify the Occupancy Classification / Building Type',
			selectedFirstRadiosGroup: 'first',
			selectedSecondRadiosGroup: 'first',
			activeRadio: null,
			checked: false,
			showCollapseA: false,
			showCollapseB: false,
			wichPopup: '',
			is_desktop: true,
			insideA: false,
			insideB: false
		}
	},
	mounted: function () {
		this.isDesktop()
		window.addEventListener('resize', this.isDesktop)
	},
	methods: {
		isDesktop: function () {
			let widthPage = document.documentElement.clientWidth
			if (widthPage >= 993) {
				this.is_desktop = true
			} else {
				this.is_desktop = false
			}
		},
		whereAreWeFirst: function (value) {
			// This method detect if select correct option return true
			if (this.selectedFirstRadiosGroup === value) {
				this.titlemessages = this.guideMessages[2]
				return true
			}
		},
		whereAreWeSecond: function (value) {
			// This method detect if select correct option return true
			if (this.selectedSecondRadiosGroup === value) {
				this.titlemessages = this.guideMessages[2]
				return true
			}
		},
		changeTitleAndOpenAccordeon: function (value) {
			if (value === 1) {
				this.behaveA()
			} else {
				this.behaveB()
			}
			this.valueOfAccordionA()
			this.valueOfAccordionB()

			this.selectedFirstRadiosGroup = false
			this.selectedSecondRadiosGroup = false

			if (this.showCollapseA || this.showCollapseB) {
				this.titlemessages = this.guideMessages[1]
			} else {
				this.titlemessages = this.guideMessages[0]
			}
		},
		behaveA: function () {
			this.showCollapseA = !this.showCollapseA
			this.showCollapseB = false
		},
		behaveB: function () {
			this.showCollapseB = !this.showCollapseB
			this.showCollapseA = false
		},
		showModal (value) {
			this.wichPopup = value
			this.$refs.myModalRef.show()
		},
		hideModal () {
			this.$refs.myModalRef.hide()
		},
		valueOfAccordionA: function () {
			if (!this.showCollapseA) {
				eventBus.$emit('value-accordion-a', this.showCollapseA)
			}
		},
		valueOfAccordionB: function () {
			if (!this.showCollapseB) {
				eventBus.$emit('value-accordion-b', this.showCollapseB)
			}
		}
	}
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/resources/content-cost-estimator.vue